export default {
    state: 'Department / State',
    statePlaceHolder: 'Select a state',
    noState: 'State not found',
    noStates: 'States not found',
};
